import { Component, Input, Output, EventEmitter } from '@angular/core';

import { visualizacaoModoPipeline, isVisualizacaoModoPipeline, visualizacaoModoList, visualizacaoModoDashboard, isVisualizacaoModoDashboard, isVisualizacaoModoList, VisualizacaoModo } from '../../../../common/visualizacao-modo';
import { CampanhaVisualizacao } from './campanha-visualizacao';
import { CampanhaVisualizacaoStorageService } from './campanha-visualizacao-storage.service';

@Component({
    selector: 'sgt-campanha-visualizacao',
    templateUrl: './campanha-visualizacao.component.html',
    styleUrls: ['./campanha-visualizacao.component.less']
})
export class CampanhaVisualizacaoComponent {
    visualizacaoModos = [visualizacaoModoList, visualizacaoModoPipeline, visualizacaoModoDashboard];

    @Input() storageKey: string;
    @Input() visualizacao: CampanhaVisualizacao;
    @Input() modoDefault: VisualizacaoModo = visualizacaoModoPipeline;
    @Output() visualizacaoChange = new EventEmitter<CampanhaVisualizacao>();
    @Output() changeModo = new EventEmitter<void>();

    constructor(private campanhaVisualizacaoStorageService: CampanhaVisualizacaoStorageService) { }

    ngOnInit(): void {
        this.visualizacao = this.campanhaVisualizacaoStorageService.get(this.storageKey, this.modoDefault);
        this.visualizacaoChange.emit(this.visualizacao);
    }

    /** Ao alterar o modo de visualização */
    onChangeVisualizacaoModo(modo: number) {
        this.visualizacao.modo = modo;
        setTimeout(() => this.changeModo.emit(), 0);
    }

    /** Verifica se o modo de visualização selecionado é o modo Table */
    isModoTable(): boolean {
        return isVisualizacaoModoList(this.visualizacao?.modo);
    }

    /** Verifica se o modo de visualização selecionado é o modo Pipeline */
    isModoPipeline(): boolean {
        return isVisualizacaoModoPipeline(this.visualizacao?.modo);
    }

    /** Verifica se o modo de visualização selecionado é o modo Dashboard */
    isModoDashboard(): boolean {
        return isVisualizacaoModoDashboard(this.visualizacao?.modo);
    }

    setStorage() {
        // Visualização
        this.campanhaVisualizacaoStorageService.set(this.storageKey, this.visualizacao);
    }
}
